const toggleDurationMs = 225;
const accordion = "diba1wj0ck5";
const heading = "dibhg7kip3";
const button = "dibbuh3pc7";
const chevron = "dibcu506tp";
const content = "dibcm40izk";

export { accordion, button, chevron, content, heading, toggleDurationMs };
import "./accordion.style.linaria.module.css";
//# sourceMappingURL=accordion.style.js.map
